import { useLoad } from "@/lib/hooks";

const n = (v) => (v == null ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 3 }));
const REASON = { no_finish_size: "No finish size on the job, so enter the quantity manually", no_material_size: "Material has no sheet/roll size in Inventory", does_not_fit: "Finish size doesn't fit this material" };

export function MaterialNeed({ jobId }) {
  const [d] = useLoad(`/inventory/material-need/${jobId}`);
  if (!d) return null;
  const ups = d.materials.find((m) => m.ups)?.ups;
  return (
    <div className="mx-5 mb-5 space-y-3" data-testid="job-material-need">
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-1 text-sm" data-testid="job-finish-size">
        <span className="text-slate-500">Finish size</span>
        <b>{d.finish_size_mm ? `${n(d.finish_size_mm[0])} x ${n(d.finish_size_mm[1])} mm` : "Not set"}</b>
        {ups && <span className="text-slate-500" data-testid="job-ups">{ups} up per sheet</span>}
      </div>
      {d.materials.length > 0 && <div className="overflow-x-auto rounded-lg border border-slate-200">
        <table className="po-table" data-testid="material-need-table">
          <thead><tr><th>Material need</th><th className="po-num">Required</th><th className="po-num">Issued</th><th className="po-num">In stock</th><th className="po-num">Shortfall</th></tr></thead>
          <tbody>{d.materials.map((m) => (
            <tr key={m.item_id} data-testid={`material-need-row-${m.code}`}>
              <td>{m.name}<div className="text-xs text-slate-400">{m.total_required != null ? `${m.summary || ""}${m.waste_pct != null && !/waste/.test(m.summary || "") ? ` · incl. ${m.waste_pct}% waste` : ""}` : REASON[m.reason] || "Enter quantity manually"}</div></td>
              <td className="po-num">{m.total_required != null ? `${n(m.total_required)} ${m.uom}` : "—"}</td>
              <td className="po-num">{n(m.issued)} {m.uom}</td>
              <td className="po-num">{n(m.available)} {m.uom}</td>
              <td className={`po-num font-semibold ${m.shortfall > 0 ? "text-rose-700" : "text-emerald-700"}`} data-testid={`material-need-shortfall-${m.code}`}>{m.required == null ? "—" : m.shortfall > 0 ? `${n(m.shortfall)} ${m.uom}` : "None"}</td>
            </tr>))}</tbody>
        </table></div>}
    </div>
  );
}
